var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ASelect',{staticClass:"w-full",attrs:{"placehoder":"مقدار"},on:{"change":_vm.search},model:{value:(_vm.input),callback:function ($$v) {_vm.input=$$v},expression:"input"}},_vm._l((_vm.items),function(i,k){return _c('ASelectOption',{key:k},[_vm._v("\n      "+_vm._s(i)+"\n    ")])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }